var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _circle, _circle2, _circle3, _path8, _path9, _path10, _rect2, _path11, _rect3, _path12, _rect4, _rect5, _rect6, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 405.67004,
    height: 457.17619,
    viewBox: "0 0 405.67004 457.17619",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M155.53307,279.99431c2.30531,4.46264,1.87197,9.26954-.9679,10.73656-2.83986,1.46701-7.01082-.9614-9.31612-5.42405-1.00911-1.95345-1.49335-3.97285-1.48081-5.74922l-9.53101-19.03203,9.02648-4.28245,8.43766,19.21639c1.45595,1.01779,2.82259,2.58135,3.8317,4.5348Z",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "84.60533 451.71752 92.73168 451.71672 96.59743 420.3719 84.60368 420.37272 84.60533 451.71752",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.44719,451.53317h0c.25301,.42612,.38653,1.80152,.38653,2.29709h0c0,1.52326-1.23484,2.7581-2.75809,2.7581h-25.16634c-1.03917,0-1.88158-.84241-1.88158-1.88158v-1.04776s-1.24497-3.14904,1.3182-7.03041c0,0,3.18565,3.03919,7.94583-1.72099l1.40373-2.54295,10.1611,7.43128,5.63215,.69326c1.23218,.15167,2.32465-.02354,2.95847,1.04395Z",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "46.48117 451.71752 54.60752 451.71672 58.47327 420.3719 46.47952 420.37272 46.48117 451.71752",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32303,451.53317h0c.25301,.42612,.38653,1.80152,.38653,2.29709h0c0,1.52326-1.23484,2.7581-2.75809,2.7581h-25.16634c-1.03917,0-1.88158-.84241-1.88158-1.88158v-1.04776s-1.24497-3.14904,1.3182-7.03041c0,0,3.18565,3.03919,7.94583-1.72099l1.40373-2.54295,10.1611,7.43128,5.63215,.69326c1.23218,.15167,2.32465-.02354,2.95847,1.04395Z",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "34.97848 266.77741 31.55506 287.6983 42.2057 355.40594 44.86836 437.18763 59.24792 437.18763 66.55002 359.9705 65.78926 308.99958 82.90636 437.94839 97.849 437.94839 99.26269 276.28691 34.97848 266.77741",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.85634,158.36912h26.92012l23.29004,13.69368c-3.62484-.92135-6.42515,32.70809-6.5204,62.42281-.00633,1.97451-1.96294,4.24471-1.94483,6.17336,.0156,1.66172,2.00271,2.98925,2.03722,4.60133,.03225,1.50656,.07291,2.98829,.12227,4.4393,.04098,1.20464-2.21263,2.80044-2.15949,3.95936,.06788,1.48053,2.44639,2.50867,2.53471,3.90206,.54298,8.56572,1.47886,15.35199,2.88747,18.72588,0,0-60.10003,16.73672-64.66459-9.12912,0,0,.26066-9.29699,.22408-22.13565-.00325-1.13908-.97335-2.17236-.98166-3.36318-.00618-.88537,.95064-1.91761,.94128-2.82771-.0077-.74818-.93124-1.40943-.94128-2.17229-.00598-.45469,.90232-1.00655,.89545-1.46594-.36498-24.41361-2.00419-55.18077-7.74547-63.13023l25.10508-13.69368Z",
    fill: "#ff0027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.48294,158.36912s17.4438,6.33911,22.97888,11.38909c2.94129,2.68351,22.66672,53.27551,22.66672,53.27551l27.39784,47.71441-14.24142,5.40954-29.13238-43.99483-12.93292-28.90888-16.73672-44.88484Z",
    fill: "#ff0027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.30131,281.79985c2.54422,4.33089,2.37252,9.15422-.3835,10.77327-2.75602,1.61905-7.05268-.57931-9.59689-4.9102-1.11369-1.89578-1.70686-3.8859-1.79079-5.66034l-10.55035-18.48644,8.78063-4.76625,9.46862,18.7299c1.50906,.93723,2.95859,2.42428,4.07228,4.32006Z",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.05254,181.95267l-7.6076-17.49748s-17.87786,5.7057-17.87786,14.07406c0,0-10.65064,63.90383-9.12912,79.87979l9.88988,17.49748,14.07406-11.03102-8.74874-20.16014,19.39938-62.76269Z",
    fill: "#ff0027"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.40674 295.62938 42.38042 277.80843 52.85634 292.26286 43.42802 301.39198 33.40674 295.62938",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.06273,
    cy: 135.93185,
    r: 17.41061,
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.63923,116.48275c-3.02557-.96901-4.45717-4.56794-7.22476-6.12798-3.06065-1.72524-6.72217-2.80225-10.09728-1.8261-2.07087,.59896-3.87505,1.92276-5.94739,2.51668-.36226,.10383-.74339,.17541-1.13032,.21227-2.2287,.21232-4.14206,1.54889-5.25588,3.49095l-.02909,.05018c-.65386,1.11896-1.58328,2.04571-2.40816,3.04522-3.01009,3.64763-4.63927,8.38811-4.60573,13.11724,.03603,5.08346,1.99201,10.13051,5.39105,13.91061l.86829-.40033c2.09834,1.81253,4.19667,3.62506,6.29505,5.43758-1.14194-4.12047-2.29454-8.38517-1.68998-12.6179,.60453-4.23281,3.451-8.45577,7.64789-9.273,1.58769-.30907,3.2622-.12225,4.80339-.61304,1.54123-.4908,2.96079-2.07527,2.43206-3.60399,.95434,2.52305,4.51392,2.37403,6.96388,3.5028,5.48344,2.52636,3.47618-1.37793,8.23617,2.33599,1.60783-8.91089,7.76669-9.30882-4.24917-13.15719Z",
    fill: "#2f2e41"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,455.98619c0,.66003,.53003,1.19,1.19006,1.19H404.48004c.65997,0,1.19-.52997,1.19-1.19,0-.65997-.53003-1.19-1.19-1.19H1.19006c-.66003,0-1.19006,.53003-1.19006,1.19Z",
    fill: "#ccc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M351.72174,457.17619H175.29695c-21.51191,0-39.01333-17.50142-39.01333-39.01374V39.01333c0-21.51191,17.50142-39.01333,39.01333-39.01333h176.4248c21.51151,0,39.01293,17.50142,39.01293,39.01333V418.16245c0,21.51232-17.50142,39.01374-39.01293,39.01374Z",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M390.73483,139.4635c-.91025,0-1.65045,.74021-1.65045,1.65045v52.81453c0,.91025,.74021,1.65045,1.65045,1.65045s1.65045-.74021,1.65045-1.65045v-52.81453c0-.91025-.74021-1.65045-1.65045-1.65045Z",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M387.0215,39.01362V418.15594c0,18.7244-14.57349,34.04062-33.00082,35.22894h-.00826c-.27234,.01652-.54463,.03304-.82523,.0413-.48691,.02473-.97376,.03299-1.46888,.03299,0,0-1.81551-.13206-5.13294-.37962-3.35042-.24756-8.22749-.61892-14.30946-1.10578-1.82372-.14032-3.74651-.29712-5.77659-.46213-4.04358-.33011-8.48331-.69321-13.24488-1.10583-1.89801-.1568-3.86206-.33006-5.86735-.50338-10.24931-.883-21.72824-1.91453-33.83431-3.08634-2.04655-.18984-4.10961-.38788-6.1892-.59419-.54463-.05777-1.09757-.10728-1.65045-.16506-8.63189-.84996-125.71564-23.47767-125.71564-27.90092V39.01362c0-19.50007,15.80312-35.30319,35.30324-35.30319h21.07628c3.36694,0,6.07366,2.62422,6.36252,5.9829,.02473,.22283,.04951,.4456,.09076,.66843,.61066,3.3752,3.70526,5.72708,7.13818,5.72708h107.08205c3.43292,0,6.52752-2.35188,7.13818-5.72708,.04125-.22283,.06603-.4456,.09081-.66843,.28881-3.35868,2.99553-5.9829,6.36247-5.9829h21.07633c19.50007,0,35.30319,15.80312,35.30319,35.30319Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.45854,99.8526c-.91025,0-1.65045,.74021-1.65045,1.65045v13.20363c0,.91025,.74021,1.65045,1.65045,1.65045s1.65045-.74021,1.65045-1.65045v-13.20363c0-.91025-.74021-1.65045-1.65045-1.65045Z",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.45854,139.4635c-.91025,0-1.65045,.74021-1.65045,1.65045v25.58204c0,.91025,.74021,1.65045,1.65045,1.65045s1.65045-.74021,1.65045-1.65045v-25.58204c0-.91025-.74021-1.65045-1.65045-1.65045Z",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M135.45854,175.77349c-.91025,0-1.65045,.74021-1.65045,1.65045v25.58204c0,.91025,.74021,1.65045,1.65045,1.65045s1.65045-.74021,1.65045-1.65045v-25.58204c0-.91025-.74021-1.65045-1.65045-1.65045Z",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 163.92888,
    y: 9.49024,
    width: 32.18385,
    height: 4.12614,
    rx: 0.31021,
    ry: 0.31021,
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 335.85723,
    cy: 10.31547,
    r: 3.30091,
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.93473,
    cy: 10.31547,
    r: 3.30091,
    fill: "#e6e6e6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 354.01223,
    cy: 10.31547,
    r: 3.30091,
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M333.5095,95.15896H193.5095c-2.20557,0-4-1.79443-4-4s1.79443-4,4-4h140c2.20557,0,4,1.79443,4,4s-1.79443,4-4,4Z",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M357.04981,411.65896h-52c-2.20557,0-4-1.79443-4-4s1.79443-4,4-4h52c2.20557,0,4,1.79443,4,4s-1.79443,4-4,4Z",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M218.04981,411.65896h-52c-2.20557,0-4-1.79443-4-4s1.79443-4,4-4h52c2.20557,0,4,1.79443,4,4s-1.79443,4-4,4Z",
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 165.96895,
    y: 105.90701,
    width: 195.08105,
    height: 1,
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M333.5095,156.15896H193.5095c-2.20557,0-4-1.79443-4-4s1.79443-4,4-4h140c2.20557,0,4,1.79443,4,4s-1.79443,4-4,4Z",
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 165.96895,
    y: 166.90701,
    width: 195.08105,
    height: 1,
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M333.5095,217.15896H193.5095c-2.20557,0-4-1.79443-4-4s1.79443-4,4-4h140c2.20557,0,4,1.79443,4,4s-1.79443,4-4,4Z",
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 165.96895,
    y: 227.90701,
    width: 195.08105,
    height: 1,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 165.96895,
    y: 279.90701,
    width: 195.08105,
    height: 1,
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 165.96895,
    y: 331.90701,
    width: 195.08105,
    height: 1,
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.88227,
    cy: 310.48573,
    r: 58,
    fill: "#ff0027"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopMobile);
export default __webpack_public_path__ + "static/media/desktop-mobile.c0240da53f7dffc0791ad079126110f3.svg";
export { ForwardRef as ReactComponent };